import { Float } from '../native/Float.js';
/**
 * @name f64
 * @description
 * A 64-bit float
 */
export class f64 extends Float.with(64) {
    constructor() {
        super(...arguments);
        // NOTE without this, we cannot properly determine extensions
        this.__FloatType = 'f64';
    }
}
